import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Reviews from './Reviews';
import Footer from 'src/components/Footer';
import SmallHeader from '../Van/singleVanPage/SmallHeader';
import MainHostInfo from '../Van/components/Modal/HostModal/components/MainInfo';
import ExtrasHost from '../Van/components/Modal/HostModal/components/Extras';
import HostPageVans from './Vans';
import Map from 'src/pages/Van/singleVanPage/Map';
import { initFilter } from 'src/store/reducers/van';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import './styles.scss';
import './media.scss';

const HostPage: FC = () => {
  const { getHost, getLocations, setupFilters } = useActions();
  const { id } = useParams();
  const host = useTypedSelector(state => state.host.host);
  const isLoadingGetHost = useTypedSelector(state => state.host.isLoading.get);

  useEffect(() => {
    if (id) {
      getHost(id);
      getLocations();
      setupFilters({
        ...initFilter,
        tags: [id.toUpperCase()]
      });
    }
  }, [id]);

  return (
    <>
      <div className='host-page__filling' />
      <div className='header'>
        <SmallHeader isLogout={false} />
      </div>
      <div className='host-page'>
        {isLoadingGetHost ? (
          <div className='host-page__loading'>
            <CircularProgress size={100} />
          </div>
        ) : (
          host && (
            <div className='host-page__wrapper'>
              <div className='host-page__top'>
                <MainHostInfo host={host} />
                <div className='hostModal__top__description'>
                  <h4>Hi, I am {host.first_name}</h4>
                  <h6>Thanks for considering us for your next Sprinter Van Rental!</h6>
                  <p>{host.description}</p>
                  <div className='host-page__top__info'>
                    <ExtrasHost />
                  </div>
                </div>
              </div>
              {host.feedback.length ? <Reviews host={host} /> : <></>}
              <HostPageVans />
              <Map address={`${host.state} ${host.city}`} />
            </div>
          )
        )}
      </div>
      <Footer />
    </>
  );
};
export default HostPage;
